import React from 'react';
import classNames from 'clsx';

import { SubLabelProps } from './SubLabel.interfaces';
import { useStyles } from './SubLabel.styles';

const SubLabel = ({ children, floated }: SubLabelProps) => {
  const classes = useStyles();

  return (
    <span
      className={classNames(classes.subLabel, {
        [classes.subLabelNotFloating]: !floated,
      })}
    >
      {children}
    </span>
  );
};

export default SubLabel;
